module.exports = __webpack_public_path__ + "img/ba_warning.4ee6749d.svg";